module.exports = __webpack_public_path__ + "static/media/frame3a.25000b0c.jpg";